import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  Dialog,
  withMobileDialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  TextField,
  Chip,
} from '@material-ui/core'
import { toggleDeleteDialog } from 'actions/view'
import { deleteEntity } from 'actions/data'
import { isPinnedSelector } from 'selectors/userpin'
import { DATA_API_URL } from 'utils/AllURLs'

const deleteIfPinned =
  (entityId, entityType, entitySubtype) => (dispatch, getState) => {
    console.log('deleteIfPinned')

    const entityTypeToEndpointMap = {
      template: `${entitySubtype}/template`,
      form: 'customform',
      group: 'contactgroup',
    }

    const secondary_id = entityTypeToEndpointMap[entityType] || entityType

    const isPinned = isPinnedSelector(getState(), secondary_id, entityId)
    console.log('isPinned: ', isPinned)

    if (isPinned) {
      const userpin = getState().userpins?.[secondary_id]?.[entityId]
      const userpinId = userpin?.id
      console.log('userpinId: ', userpinId)

      if (userpinId) {
        return dispatch(
          deleteEntity(
            userpinId,
            'userpin',
            `${DATA_API_URL}/userpin/${userpinId}`,
            'none',
            null,
            userpin,
          ),
        )
      } else {
        console.log('error: no userpinId found')
      }
    }
  }

const DeleteDialogComponent = connect(null, (dispatch, { entityType }) => {
  const deleteFn = entityType
    ? require('./routes')?.[entityType]?.deleteFn
    : null
  const actions = deleteFn
    ? { toggleDeleteDialog, deleteEntity, deleteIfPinned, deleteFn }
    : { toggleDeleteDialog, deleteIfPinned, deleteEntity }
  return bindActionCreators(actions, dispatch)
})(
  withMobileDialog()(
    class DeleteDialog extends Component {
      state = {
        deleteConfirmationInputText: '',
        confirmRemoveFromCampaignChecked: false,
      }

      clickConfirmDelete = confirmed => {
        const {
          entityType,
          id,
          deleteEntity,
          /* entity, */ deleteFn,
          entitySubtype,
        } = this.props

        const deleteFunc = () => {
          return deleteFn
            ? Promise.resolve(deleteFn(id, entitySubtype))
            : deleteEntity(id, entityType)
        }

        if (
          confirmed &&
          this.state.deleteConfirmationInputText.toUpperCase() === 'DELETE'
        ) {
          deleteFunc().then(() => {
            this.props.deleteIfPinned(
              id,
              /* 	
								We're usng `entitySubtype` (which in some places was just `type``)
								for `sms/template`, `email/template`, and for customforms to
								differentiate between integrations and forms. However, the endpoints
								for forms and integrations aren't 'different while the endpoints for
								sms and email templates are different.
								We should maybe consider having lists with multiple `entityType`s.
							*/
              entityType,
              // entityType === 'template' && entitySubtype
              //   ? `${entitySubtype}/${entityType}`
              //   : entityType,
              entitySubtype,
            )
            this.props.toggleDeleteDialog()
          })
        } else {
          this.props.toggleDeleteDialog()
        }
        this.setState({
          deleteConfirmationInputText: '',
        })
      }

      onDeleteConfirmationInputChange = event => {
        this.setState({
          ...this.state,
          deleteConfirmationInputText: event.target.value,
        })
      }

      render() {
        const { fullScreen, deleteDialogOpen, name, entityType, entity } =
          this.props
        // console.log(entity)
        // console.log(entity && entity.owned_by)

        const entityTypeLabels = {
          contactgroup: 'contact group',
          signupform: 'signup form',
        }

        const label = entityTypeLabels[entityType] || entityType

        return (
          <Dialog
            fullScreen={fullScreen}
            open={deleteDialogOpen}
            aria-labelledby="responsive-dialog-title"
            style={{ borderRadius: 22 }}
          >
            <DialogTitle id="responsive-dialog-title">
              {`Are you sure you want to delete this ${label}?`}
            </DialogTitle>
            <DialogContent>
              {entity && entity.owned_by ? <div>Checkbox here</div> : null}
              <DialogContentText>
                <Chip style={{ margin: 4 }} label={name} />
              </DialogContentText>
            </DialogContent>
            <div style={{ width: '100%', padding: 16 }}>
              <TextField
                variant="outlined"
                onChange={e => {
                  this.onDeleteConfirmationInputChange(e)
                }}
                style={{ width: '100%' }}
                helperText={`Type in the word 'DELETE' in the field above and press 'CONFIRM' to delete this ${label}.`}
              />
            </div>
            <DialogActions>
              <Button
                autoFocus
                onClick={() => {
                  this.clickConfirmDelete(false)
                }}
                color="secondary"
              >
                Never Mind
              </Button>
              <Button
                onClick={() => {
                  this.clickConfirmDelete(true)
                }}
                color="primary"
                disabled={
                  this.state.deleteConfirmationInputText.toUpperCase() !==
                  'DELETE'
                }
                autoFocus={
                  this.state.deleteConfirmationInputText.toUpperCase() !==
                  'DELETE'
                }
              >
                Confirm
              </Button>
            </DialogActions>
          </Dialog>
        )
      }
    },
  ),
)

export default connect(
  state => ({ ...state.delete }),
  null,
)(DeleteDialogComponent)
